export default __webpack_public_path__ + "static/media/pacha.80ad3218.jpg";